// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";

var id = "menu-brand";

function Organism_Menu_Brand(Props) {
  var brand = Props.brand;
  var view = Props.view;
  var children = Props.children;
  var brandTitleStyle = view.brandTitleStyle;
  if (brand === undefined) {
    return children;
  }
  if (brandTitleStyle === undefined) {
    return children;
  }
  var logo = brand.logo;
  return React.createElement(Atom_Row.make, {
              children: null,
              id: id,
              rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.position(CssJs.unset)]),
              wrap: /* OnOneLine */1
            }, React.createElement(Atom_Cta.Link.make, {
                  href: logo._0,
                  screenReadersLabel: logo._1,
                  style: /* MenuBrandLogo */12
                }), React.createElement(Atom_Cta.Link.make, {
                  href: brand.titleHref,
                  label: brand.title,
                  labelKind: brand.titleKind,
                  style: brandTitleStyle
                }), children);
}

var make = Organism_Menu_Brand;

export {
  id ,
  make ,
}
/* CssJs Not a pure module */
